// The legal texts live on the landing site; the app links there and keeps no
// copy of its own (privacy decision 2026-10-31).
export const TERMS_URL = 'https://basiqr.com/terms';
export const PRIVACY_URL = 'https://basiqr.com/privacy';
export const COOKIE_NOTICE_URL = 'https://basiqr.com/privacy#cookies';

/**
 * The version of the Terms and Privacy Policy the sign-up forms show: the
 * month the texts took effect. Sent with the confirm-code call and recorded
 * on the new users row (backend/src/config/terms.ts). Change it with the texts.
 */
export const TERMS_VERSION = '2026-11';
